import { globalOptions } from 'Dictionaries/imports/importOptionsDictionary.js';
import { merge } from 'lodash';

export const options = merge(
    {
        identifiers: {
            contact: {
                title: window.i18n.__('Critère de comparaison pour les contacts'),

                choices: [
                    {
                        value: 'contact_id',
                        label: window.i18n.__('Identifiant contact'),
                        description: window.i18n.__('Récupéré uniquement depuis un export Sellsy.'),
                    },
                    {
                        value: 'contact_last_name',
                        label: window.i18n.__('Nom contact'),
                        description: window.i18n.__('Nom de famille du contact.'),
                    },
                    {
                        value: 'contact_first_name',
                        label: window.i18n.__('Prénom contact'),
                        description: window.i18n.__('Prénom du contact.'),
                    },
                    {
                        value: 'contact_email',
                        label: window.i18n.__('Email contact'),
                        description: window.i18n.__('Adresse email du contact.'),
                    },
                ],
                multiple: true,
            },
        },
        parameters: {
            create: {
                options: {
                    insert_new_records: {
                        title: window.i18n.__(
                            'Si une donnée de mon fichier n’existe pas dans Sellsy',
                        ),
                        values: [
                            {
                                value: 'Y',
                                label: window.i18n.__('Ajouter la donnée'),
                                description: window.i18n.__(
                                    'La donnée du fichier est prise en compte et importée dans Sellsy.',
                                ),
                            },
                            {
                                value: 'N',
                                label: window.i18n.__('Ignorer et ne pas ajouter la donnée'),
                                description: window.i18n.__(
                                    'La donnée du fichier est ignorée et n’est pas importée dans Sellsy.',
                                ),
                            },
                        ],
                    },
                },
            },
            update: {
                options: {
                    update_existing_records: {
                        title: window.i18n.__(
                            'Si une donnée de mon fichier est identique à celle dans Sellsy',
                        ),
                        values: [
                            {
                                value: 'Y',
                                label: window.i18n.__('Mettre à jour la donnée'),
                                description: window.i18n.__(
                                    'La donnée identique du fichier trouvée par rapport au(x) critère(s) de comparaison renseigné(s) est mise à jour dans Sellsy.',
                                ),
                            },
                            {
                                value: 'N',
                                label: window.i18n.__('Ignorer et ne pas mettre à jour la donnée'),
                                description: window.i18n.__(
                                    'La donnée identique du fichier trouvée par rapport au(x) critère(s) de comparaison renseigné(s) est ignorée et n’est pas mise à jour dans Sellsy.',
                                ),
                            },
                        ],
                    },
                },
            },
        },
        description: window.i18n.__(
            'Cette section vous permet de déterminer les critères sur lesquels nous allons déterminer si un contact existe déjà dans vos données Sellsy',
        ),
    },
    globalOptions,
);
export const defaultOptions = {
    identifiers: {
        contact: ['contact_last_name', 'contact_first_name'],
    },
};
